package com.kinoshazam.screens.details.expanded

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import features.videoDetails.DetailsMVIAction
import features.videoDetails.VideoDetailsState

@Composable
actual fun ExpandedVideoDetailsWindow(
    state: VideoDetailsState,
    onAction: (DetailsMVIAction) -> Unit,
    modifier: Modifier
) {
}